import styles from './AppLock.module.css';

export function WelcomeScreen({ onEnable, onSkip }: { onEnable: () => void; onSkip: () => void }) {
  return (
    <div className={styles.screen}>
      <div className={`${styles.cardLg} ${styles.cardCenter}`}>
        <h1 className={`${styles.title} ${styles.titleLg}`}>
          Welcome to ALG
        </h1>
        <p className={styles.subtitle}>
          This app stores your allergen profiles and analysis history locally.
          Enable password protection to encrypt your data, or skip to use the app without encryption.
        </p>
        <div className={styles.buttonStack}>
          <button
            type="button"
            onClick={onEnable}
            className={styles.primaryButton}
          >
            Enable Password Protection
          </button>
          <button
            type="button"
            onClick={onSkip}
            className={styles.secondaryButton}
          >
            Skip for now
          </button>
        </div>
      </div>
    </div>
  );
}
